<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :credit-note-type="creditNoteType"
            :tenant-languages="tenantLanguages"
            :default-tenant-language="defaultTenantLanguage"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CreditNoteTypes/Form'

export default {
    name: 'CreditNoteTypeUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        creditNoteType: {
            type: Object,
            default: () => { return {} }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('settings.credit-note-types.update', this.creditNoteType.id))
        }
    }
}
</script>
